import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.module.js';

if (document.querySelector('.logoSlider__slides')) {
    let logoSlider = tns({
        container: '.logoSlider__slides',
        items: 1,
        controls: false,
        autoplay: true,
        autoplayButtonOutput: false,
        controlsText: ['', ''],
        responsive: {
            480: {
                items: 2
            },
            760: {
                items: 3
            },
            1030: {
                items: 4
            },
            1280: {
                items: 5
            }
        }
    });

    if (logoSlider) {
        document.querySelector(
            '.logoSlider__button--prev'
        ).onclick = function() {
            logoSlider.goTo('prev');
        };

        document.querySelector(
            '.logoSlider__button--next'
        ).onclick = function() {
            logoSlider.goTo('next');
        };
    }
}



// WEBPACK FOOTER //
// ./src/components/logoSlider/logoSlider.js